// extracted by mini-css-extract-plugin
export var blockContent = "CitySection-module--blockContent--+m0KD";
export var citySection = "CitySection-module--citySection--0I52u";
export var container = "CitySection-module--container--jFQWs";
export var headline = "CitySection-module--headline--1TDFB";
export var twoCols = "CitySection-module--twoCols--jUoCY";